import { Box, Flex, FlexProps, Text } from '@chakra-ui/react'
import { IoMdCloseCircleOutline } from 'react-icons/io'
import { useTranslation } from 'next-i18next/pages'

export const NoResultsFallback = ({
  text,
  styles,
  icon,
  render,
}: {
  text?: string
  styles?: FlexProps
  icon?: React.ReactElement
  render?: () => React.ReactElement
}) => {
  const { t } = useTranslation()
  const defaultText = t('common.no-games-played')
  return (
    <Flex
      mb={6}
      rounded={'xl'}
      borderColor={'ninja.500'}
      borderStyle={'solid'}
      borderWidth={'1px'}
      h={155}
      px={4}
      justifyContent={'center'}
      alignItems={'center'}
      flexDir={'column'}
      color={'ninja.200'}
      {...styles}
    >
      <Box flexShrink={0}>{icon ? icon : <IoMdCloseCircleOutline fontSize={40} />}</Box>
      <Text maxW={'320px'} flexShrink={0} textAlign={'center'} mt={2} lineHeight={1.3} fontWeight={700}>
        {text || defaultText}
      </Text>
      {render?.()}
    </Flex>
  )
}
